'use client';

import { c } from 'ui-components';
import { Skeleton } from './Skeleton';

type SidebarSkeletonProps = {
  className?: string;
};

export const SidebarSkeleton = ({ className }: SidebarSkeletonProps) => {
  return (
    <div
      className={c('flex animate-pulse flex-col gap-6', className)}
      aria-hidden
    >
      <div className="flex flex-col gap-2">
        <Skeleton className="mb-1 h-6 w-16" />
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-6 w-2/3" />
      </div>
      <div className="flex flex-col gap-2">
        <Skeleton className="mb-1 h-6 w-24" />
        <Skeleton className="h-6 w-full" />
        <Skeleton className="h-6 w-4/5" />
        <Skeleton className="h-6 w-3/5" />
        <Skeleton className="h-6 w-2/3" />
        <Skeleton className="h-6 w-1/2" />
      </div>
      <div className="flex flex-col gap-2">
        <Skeleton className="mb-1 h-6 w-28" />
        <Skeleton className="h-6 w-3/4" />
      </div>
    </div>
  );
};
